// extracted by mini-css-extract-plugin
export var addViewLink = "_k-1";
export var availabilityIcon = "_k-16";
export var availabilitySelectionIcon = "_k-15";
export var backButton = "_k-2";
export var backIcon = "_k-z";
export var conversationCount = "_k-3";
export var dragHandle = "_k-5";
export var dropdown = "_k-e";
export var dropdownIcon = "_k-7";
export var dropdownOption = "_k-6";
export var dropdownTriangle = "_k-d";
export var expand = "_k-f";
export var folder = "_k-i";
export var folderItem = "_k-c";
export var icon = "_k-8";
export var iconRow = "_k-9";
export var image = "_k-a";
export var logo = "_k-b";
export var navContainer = "_k-h";
export var navigationFooter = "_k-g";
export var pageShell = "_k-0";
export var placeholderAvailable = "_k-11";
export var placeholderBox = "_k-14";
export var placeholderBusy = "_k-13";
export var placeholderUnavailable = "_k-12";
export var profile = "_k-k";
export var profileContainer = "_k-m";
export var profileDropdown = "_k-n";
export var profileImage = "_k-l";
export var profileMain = "_k-o";
export var profileSubtitle = "_k-q";
export var profileTitle = "_k-p";
export var reorderIcon = "_k-r";
export var sentLine = "_k-u";
export var settingsHeader = "_k-s";
export var sidenavTextColor = "_k-y";
export var spamLine = "_k-t";
export var subitemWithTag = "_k-4";
export var supportItems = "_k-j";
export var teamText = "_k-10";
export var viewLine = "_k-x";
export var viewLineButton = "_k-w";
export var viewLineButtons = "_k-v";